<template>
	<div>
		<Loading v-if="loading && !initiallyLoaded" text="Lade Verabschiedungen..."/>
		<template v-else>
			<JonInfo v-if="!isListTypeCustomer" class="mb-5">
				<template #message>
					Hier werden Jobs/Arbeitgeber angezeigt, von denen du dich verabschiedet hast oder bei denen der
					Arbeitgeber sich von dir verabschiedet hat.
				</template>
			</JonInfo>
			<div class="my-3">
				<b-form-radio-group
					v-model="filterType"
					:options="filterTypeOptions"
					@change="filterTypeChanged"
				/>
			</div>
			<div v-if="sendoffs.length > 0" :class="['items-list', {'loading-blockade': loading}]">
				<!--<div class="p-2 font-weight-extra-bold">
					<b-row align-v="center">
						<b-col :md="isListTypeCustomer ? 3 : 6">Job</b-col>
						<b-col v-if="isListTypeCustomer" md="3">Person</b-col>
						<b-col md="3">Verabschiedet durch</b-col>
						<b-col md="3">Verabschiedung</b-col>
					</b-row>
				</div>-->
				<ListItem
					v-for="item in sendoffs"
					:key="item.id"
					:list-item="item"
					:list-type="type"
					@remove="loadSendoffs"
				/>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="loadSendoffs"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import GetList from "@/api/sendoff/GetList";
import Pagination from "@/vue/common/Pagination";
import ListItem from "./ListItem";
import JonInfo from "@/vue/common/JonInfo";

export const LIST_TYPE_CUSTOMER = 'customer';
export const LIST_TYPE_APPLICATION = 'application';

export const FILTER_TYPE__ME = 'me';
export const FILTER_TYPE__OPPOSITE = 'opposite';

export default {

	components: {
		Loading,
		Pagination,
		ListItem,
		JonInfo
	},

	props: {
		type: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		this.loadSendoffs();
	},

	data ()
	{
		return {
			loading: true,
			sendoffs: null,
			meta: null,
			page: 1,
			itemsPerPage: 10,
			initiallyLoaded: false,
			filterType: null,
		};
	},

	computed: {
		filterTypeOptions ()
		{
			const oppositeText = this.type === LIST_TYPE_CUSTOMER
				? 'Kandidat hat sich verabschiedet'
				: 'Organisation hat sich verabschiedet';

			return [
				{ value: null, text: 'Alle Verabschiedungen' },
				{ value: FILTER_TYPE__ME, text: 'Ich habe mich verabschiedet' },
				{ value: FILTER_TYPE__OPPOSITE, text: oppositeText },
			];
		},
		isListTypeCustomer ()
		{
			return this.type === LIST_TYPE_CUSTOMER;
		},
	},

	methods: {
		filterTypeChanged ()
		{
			this.page = 1;

			this.loadSendoffs();
		},
		async loadSendoffs ()
		{
			this.loading = true;

			const getList = new GetList()
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage);

			if (this.filterType)
			{
				getList.setFilterType(this.filterType);
			}

			const response = await getList.call();

			this.sendoffs = response.data;
			this.meta = response.meta;

			this.loading = false;
			this.initiallyLoaded = true;
		}
	}
}
</script>
